export default __webpack_public_path__ + "static/media/transition.7f8df6ed.svg";